import React from 'react';
import { motion } from 'framer-motion';
import { AiOutlineHeart } from 'react-icons/ai'
import { FaAngleRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Meta } from '../components'
import BreadCrumb from '../ScreenComponents/ShearCompo/BreadCrumb/BreadCrumb'
import '../screens/Css/ShippingScreen.scss'

export default function WishlistScreen() {

    const stagger = {
        hidden: { opacity: 0, y: 5 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.3,
                duration: 0.3,
                delay: 0.2,
            },
        },
    };

    return (
        <motion.div
            exit={{ opacity: 0 }}
            variants={stagger}
            initial='hidden'
            animate='visible'
            className='empty_cart'
        >
            <Meta title={'Your cart list __bubu Shopkpr'} />
            <BreadCrumb title={<span className=" d-flex items-end h-auto">
                <Link className="link" to='/'>Home</Link>
                <div className="d-flex items-center">
                    <FaAngleRight />
                    <span className="notLink">Wishlist</span>
                </div>
            </span>} />
            <div className='row my-5 empty_details colorRed relative'>
                <div className='col-md-2'>
                    <div className='cart-icon'>
                        <AiOutlineHeart />
                    </div>
                </div>
                <div className='col-md-10 d-flex justify-center items-center bgCart'>
                    <h1 className=''>Your Wishlist is currently empty</h1>
                </div>
            </div>
            <div className='continue_shopping row'>
                <Link className='col-md-4 mx-auto text-center py-3' to="/shop">Continue Shopping</Link>
            </div>
        </motion.div>
    )
}
